import React, { Component } from 'react';
import './tooltip.css';

export const TooltipSmiley = (props) => (
  <button className='tooltip' tooltip={props.content} tooltip-position={props.position} className={props.className} onClick={props.onClick} >
    {props.children}
  </button>
)

export const Tooltip = (props) => (
  <div className='tooltip' tooltip={props.content} tooltip-position={props.position} className={props.className} >
    {props.children}
  </div>
)
